var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image-list"},_vm._l((_vm.listNew),function(item,index){return _c('el-image',{key:index,attrs:{"src":item,"fit":"contain ","preview-src-list":_vm.listNew}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }